/* eslint-disable global-require */
module.exports = ['search.bars.common.closingdropdown.m1', ...require('./DisplayedCurrencies/i18n'), ...require('./DisplayedDimensions/i18n')];
